const web = new Vue({
    el: '#web',
    components: {
        'from-url-container': () => import(/* webpackChunkName: 'image-from-url' */ '../components/web/FromUrlContainer.vue'),
        'url-tracer-container': () => import(/* webpackChunkName: 'url-tracer' */ '../components/web/UrlTracerContainer.vue'),
        'detect-cms-container': () => import(/* webpackChunkName: 'detect-cms' */ '../components/web/DetectCmsContainer.vue'),
        'improve-block': () => import(/* webpackChunkName: 'improveBlock' */ '../components/shared/ImproveBlock.vue'),
    },
});
